import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"1em","padding-bottom":"0"} }
const _hoisted_2 = {
  class: "territories",
  style: {"font-size":"18px","text-align":"center"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { useI18n } from 'vue-i18n';
import KeyBlock from './keyBlock.vue';
import type { KeyRowModel } from '@/models/sidebar/keyRow.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'territories',
  setup(__props) {

const { t } = useI18n();

// TODO: Consider a better method for this
// *****TERRITORY COLORS*****
// **GLOBALS**
const neutralKeys: KeyRowModel[] = [
  { color: '#FFAD46', territory: t('keys.territory.neutral_countries') }
];

// **1948 ARAB-ISRAELI WAR**
const arab1948Keys: KeyRowModel[] = [
  { color: '#008000', territory: t('keys.territory.arab') },
  { color: '#66a103', territory: t('keys.territory.arab_puppets') },
  { color: '#80c904', territory: t('keys.territory.arab_occupied_territory') }
];

const jew1948Keys: KeyRowModel[] = [
  { color: '#296D98', territory: t('keys.territory.jews') },
  { color: '#3792CB', territory: t('keys.territory.jews_puppets') },
  { color: '#45B6FE', territory: t('keys.territory.jews_occupied_territory') }
];

const uk1948Keys: KeyRowModel[] = [
  { color: '#b30000', territory: t('keys.territory.uk_palestine') }
];

// **1956 SUEZ CRISIS**
const arab1956Keys: KeyRowModel[] = [
  { color: '#008000', territory: t('keys.territory.egypt') },
  { color: '#66a103', territory: t('keys.territory.egypt_puppets') }
];

const jew1956Keys: KeyRowModel[] = [
  { color: '#296D98', territory: t('keys.territory.israel') },
  // { color: '#3792CB', territory: t('keys.territory.jews_puppets') },
  { color: '#45B6FE', territory: t('keys.territory.israel_occupied_territory') },
];

const uk1956Keys: KeyRowModel[] = [
  { color: '#b30000', territory: t('keys.territory.uk_cyprus') },
  { color: '#ff7f7f', territory: t('keys.territory.anglo_french_egypt') },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, [
      _createElementVNode("b", null, _toDisplayString(_unref(t)('keys.title')), 1)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "info-divider" }, null, -1)),
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('keys.territories')), 1),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    (_ctx.$store.state.war == '1948-arab-israeli-war')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.neutral'),
            rows: neutralKeys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.arabs_at_war'),
            rows: arab1948Keys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.jews_at_war'),
            rows: jew1948Keys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.uk'),
            rows: uk1948Keys
          }, null, 8, ["header"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.war == 'suez-crisis')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.neutral'),
            rows: neutralKeys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.egypt'),
            rows: arab1956Keys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.israel'),
            rows: jew1956Keys
          }, null, 8, ["header"]),
          _createVNode(KeyBlock, {
            header: _unref(t)('keys.countries.uk_and_france'),
            rows: uk1956Keys
          }, null, 8, ["header"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})